import { Capacitor } from '@capacitor/core'
import { Mixpanel } from '@/analytics/mixpanel'
import { CapgoInAppReview } from '@capgo/capacitor-in-app-review'

export async function promptForRating(): Promise<boolean> {
  if (!Capacitor.isPluginAvailable('CapgoInAppReview')) {
    return false
  }

  Mixpanel.trackAppReviewShow()
  await CapgoInAppReview.requestReview()
  return true
}
